import React from 'react';

const Icon = ({ icon, className, ...props }) => {
	return <span className={`app-icon ri-${icon} ${className ? className : ''} `} {...props} />;
};

export default Icon;
